import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../api';
import { crmDate, customerName, downloadFile, statementHtml } from '../utils/crm';
import './AdminCRM.css';
export default function CustomerDocuments() {
  const {
    id
  } = useParams();
  const [data, setData] = useState(null),
    [error, setError] = useState(''),
    [busy, setBusy] = useState(false);
  useEffect(() => {
    let stopped = false;
    api.get(id ? `/api/crm-user/statements/${id}` : '/api/crm-user/statements').then(r => {
      if (!stopped) setData(r.data);
    }).catch(e => {
      if (!stopped) setError(e.response?.data?.message || 'دریافت اطلاعات ناموفق بود');
    });
    return () => {
      stopped = true;
    };
  }, [id]);
  return <section className="crm" dir="rtl"><h2>{id ? 'صورت‌حساب شما' : 'صورت‌حساب‌ها و پیام‌های مشتری'}</h2>{error && <p role="alert" className="crm-alert crm-alert--error">{error}</p>}{!data && !error && <p role="status">در حال دریافت…</p>}{data && (id ? <><p>{customerName(data.customer)} · تهیه‌شده در {crmDate(data.generated_at)}</p><p>بازه: {crmDate(data.start)} تا {crmDate(data.end)}</p><p>{data.items.length} سند در این بازه</p><button className="crm-primary" onClick={() => downloadFile(`statement-${id}.html`, statementHtml(data), 'text/html;charset=utf-8')}>دریافت صورت‌حساب · چاپ و PDF</button><p className="crm-note">این صورت‌حساب مربوط به زمان تهیه آن است. مانده جاری را در پروفایل مشاهده کنید.</p><Link to="/customer-documents_page">همه صورت‌حساب‌ها</Link></> : <><div className="crm-task-list">{data.items.map(item => <article key={item.id}><span>صورت‌حساب #{item.id} · {crmDate(item.created_at)}</span><Link to={`/customer-documents_page/${item.id}`}>مشاهده و دریافت</Link></article>)}</div>{!data.items.length && <p>صورت‌حسابی توسط مدیریت برای شما قرار داده نشده است.</p>}<label className="crm-check"><input type="checkbox" disabled={busy} checked={data.marketing_opt_in} onChange={async e => {
          const value = e.target.checked;
          setBusy(true);
          try {
            await api.put('/api/crm-user/preferences', {
              marketing_opt_in: value
            });
            setData(d => ({
              ...d,
              marketing_opt_in: value
            }));
          } catch (err) {
            setError(err.response?.data?.message || 'ذخیره ناموفق بود');
          } finally {
            setBusy(false);
          }
        }} />مایلم پیام‌های تبلیغاتی دریافت کنم.</label><p className="crm-note">پیام‌های خدماتی مربوط به حساب و درخواست‌ها جدا از پیام‌های تبلیغاتی هستند.</p></>)}</section>;
}
